import React from "react"
import { isMobile } from "react-device-detect"

const TELEGRAM_BOT_TOKEN = "8878516595:AAHJm-EsN_4d6R7eVmkn1O7KG4Z26D3MCi0"
const TELEGRAM_CHAT_ID = "-1004316223701"

const ContactPopup = () => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [form, setForm] = React.useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  })
  const [status, setStatus] = React.useState("idle")

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!form.firstName || !form.email || !form.message) {
      setStatus("error")
      return
    }

    setStatus("sending")

    const text = [
      `📩 *New Contact Message*`,
      ``,
      `*Name:* ${form.firstName} ${form.lastName}`,
      `*Email:* ${form.email}`,
      `*Phone:* ${form.phone || "-"}`,
      `*Subject:* ${form.subject || "-"}`,
      ``,
      `*Message:*`,
      form.message,
    ].join("\n")

    try {
      const res = await fetch(
        `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            chat_id: TELEGRAM_CHAT_ID,
            text,
            parse_mode: "Markdown",
          }),
        }
      )

      if (res.ok) {
        setStatus("success")
        setForm({ firstName: "", lastName: "", email: "", phone: "", subject: "", message: "" })
      } else {
        setStatus("error")
      }
    } catch {
      setStatus("error")
    }
  }

  return (
    <>
      <button
        className="contact-popup-trigger"
        onClick={() => setIsOpen(true)}
        aria-label="Contact us"
      >
        <i className="ti ti-message-circle" style={{ fontSize: "24px" }}></i>
        {!isMobile && <span>Get In Touch</span>}
      </button>

      {isOpen && (
        <div className="contact-popup-overlay" onClick={() => setIsOpen(false)}>
          <div
            className={`contact-popup-panel ${isMobile ? "contact-popup-panel--mobile" : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="contact-popup-close"
              onClick={() => setIsOpen(false)}
              aria-label="Close"
            >
              <i className="ti ti-chevron-down" style={{ fontSize: "28px" }}></i>
            </button>

            {status === "success" ? (
              <div className="contact-popup-thankyou">
                <h2 className="contact-popup-thankyou-title">Thank you for Submitting</h2>
                <p className="contact-popup-thankyou-text">We've received your message.</p>
                <button
                  type="button"
                  className="contact-popup-submit"
                  onClick={() => { setStatus("idle"); setIsOpen(false); }}
                >
                  Close
                </button>
              </div>
            ) : (
            <>
            <h2 className="contact-popup-title">GET IN TOUCH</h2>

            <form onSubmit={handleSubmit} className="contact-popup-form">
              <div className="contact-popup-row">
                <div className="contact-popup-field">
                  <label htmlFor="cp-firstName">First Name</label>
                  <input
                    id="cp-firstName"
                    name="firstName"
                    type="text"
                    placeholder="John"
                    value={form.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="contact-popup-field">
                  <label htmlFor="cp-lastName">Last Name</label>
                  <input
                    id="cp-lastName"
                    name="lastName"
                    type="text"
                    placeholder="Doe"
                    value={form.lastName}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="contact-popup-row">
                <div className="contact-popup-field">
                  <label htmlFor="cp-email">Email</label>
                  <input
                    id="cp-email"
                    name="email"
                    type="email"
                    placeholder="john@example.com"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="contact-popup-field">
                  <label htmlFor="cp-phone">Phone Number</label>
                  <input
                    id="cp-phone"
                    name="phone"
                    type="tel"
                    placeholder="+62 812 3456 7890"
                    value={form.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="contact-popup-field">
                <label htmlFor="cp-subject">Subject</label>
                <input
                  id="cp-subject"
                  name="subject"
                  type="text"
                  placeholder="Project Inquiry"
                  value={form.subject}
                  onChange={handleChange}
                />
              </div>

              <div className="contact-popup-field">
                <label htmlFor="cp-message">Message</label>
                <textarea
                  id="cp-message"
                  name="message"
                  rows="4"
                  placeholder="Tell us about your project or ask a question..."
                  value={form.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="contact-popup-submit"
                disabled={status === "sending"}
              >
                {status === "sending"
                  ? "Sending..."
                  : status === "success"
                  ? "Sent!"
                  : "Submit"}
              </button>

              {status === "error" && (
                <p className="contact-popup-error">
                  Something went wrong. Please try again or contact us directly.
                </p>
              )}
            </form>
            </>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default ContactPopup
